import { config } from "../../Config";

const SetUserRole = async (adminUserId, targetUserId, role) => {
  if (!adminUserId || !targetUserId || !role) {
    return { success: false, error: "Missing adminUserId, targetUserId, or role" };
  }
  try {
    const res = await fetch(config.setUserRole, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adminUserId, targetUserId, role }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { success: false, error: data.error || `HTTP ${res.status}` };
    }
    return { success: true, role: data.role, message: data.message };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export default SetUserRole;
